<template>
  <div class="agricultural_machinery">
    <div class="zhilian">
      <div class="item">
        <div class="item_title">
          <p>
            <img src="../../../../static/img/icon3.png" alt="">
            <img src="../../../../static/img/icon2.png" alt="">
            <img src="../../../../static/img/icon1.png" alt="">
          </p>
          <span class="tit_class">农机用户
          	<!--<img src="../../../../static/img/zhiliannongji-right-icon.png" alt="">-->
          </span>
          <!-- <span>农机用户（{{ statisticsUserSum + '个' }}）</span> -->
        </div>
        <p class="img_right2"><span>单位：个</span></p>
      </div>
      <div id='machineryUsersEchart' style="width:99%;height:20vh;"></div>
      <div class="user_class">
        <p v-for="(item, index) in getDataArr" :key="index">
          <span></span>
          <span>{{ item.typeName + '：' + item.nums }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../../Serves/net-api.js'
import Http from '../../../Serves/net-http.js'
import {mapState,mapActions,mapMutations} from "vuex";
export default {
  components:{
    
  },
  data(){
    return{
      machineryEchart: '',
      machineryUsersEchart: '',
      machineryEchart2: '',
      countNjSum: '',
      statisticsUserSum: '',
      AreaByWorkSum: '',
      getDataArr: [],
      statisticsUserData: [],
      countNjNumArr: [],
      countNjNumData: [],
      sumAreaByWorkArr: [],
      sumAreaByWorkData: []
    }
  },
  mounted(){
    setTimeout(() => {
      this.getStatisticsUserData()
    }, 500)
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.machineryUsersEchart.resize()
      })
    })
  },
  methods:{
    // 农机用户
    getStatisticsUserData () {
      var url=Http.test+'/homePageStatis/getStatisticsUser'
      Api.doPost(url,null,false,(res)=>{
        this.getDataArr = res.result
        this.statisticsUserSum = res.result[0].total
        this.statisticsUserData = res.result.map(item => {
          return {
            name: item.typeName,
            value: item.nums
          }
        })
        this.getDataEchart1()
      })
    },
    getDataEchart1 () {
      this.machineryUsersEchart=this.$echarts.init(document.getElementById('machineryUsersEchart'))
      this.machineryUsersEchart.setOption({
        // title: {
        //     text: '',
        //     x: '36%',
        //     y: '55.5%',
        //     textStyle: {
        //       fontSize: 20
        //     }
        //   },
        title: {
          text: '总数',
          // top: 20,
          textStyle: {
            color: '#fff',
            fontSize: 12,
            fontWeight:'400',
          },
          subtext: this.statisticsUserSum,
          subtextStyle: {
            color: '#fff',
            fontSize: 16,
            fontWeight:'100',
          },
          itemGap: 10,
          left: 'center',
          top: '38%'
        },
        tooltip: {
          trigger: 'item'
        },
        // tooltip: {
        //   trigger: "item",
        //   formatter: function(params) {
        //     console.log(params)
        //     var relVal = '<div class="tooltipBox"><span">'+params.name+ ' : ' + params.value +'个</span>';
        //     // for(var i = 0, l = params.length; i < l; i++) {
        //     //   // let unit = params[i].seriesName == '作业面积' ? '亩' : '台'
        //       // relVal += '<br/> <span>' + params.seriesName + ' : ' + params.value +'个</span>'
        //     // }
        //     // relVal +='</div>'
        //     return relVal
        //   }
        // },
        legend: {
          show: false,
          itemWidth: 13,
          itemHeight: 13,
          icon: "rect",
          itemGap: 10 ,
          // type: 'plain',
          orient: 'vertical',
          right: '0%',
          top: 'center',
          textStyle: {
            fontSize: 14,
            color: '#668eb9'
          },
          formatter: function(value) {
            return value + '：2000个'
          }
        },
        series: [{
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['90%', '60%'],
          // clockwise: true,
          // avoidLabelOverlap: true,
          // hoverOffset: 15,
          color: ['#007aff','#00c800','#7c00ff'],
          label: {
            show: false,
            position: 'outside',
            formatter: '{d}%',
            fontSize: 14,
            rich: {
              hr: {
                backgroundColor: 't',
                borderRadius: 3,
                width: 3,
                height: 3,
                padding: [3, 3, 0, -12]
              },
              a: {
                padding: [-30, 15, -20, 15]
              }
            }
          },
          labelLine: {
            normal: {
              length: 20,
              length2: 30,
              lineStyle: {
                width: 1
              }
            }
          },
          data: this.statisticsUserData
        }]
      })
    }
  }
}
</script>
<style scoped>
  .agricultural_machinery{
    width: 23%;
    height: 29vh;
    background-image: url(../../../../static/img/ng-left.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 10px;
  }
  p{
    color: #ccc;
  }
  .item{
    height: 4.6vh;
    line-height: 4.6vh;
    display: flex;
    justify-content: space-between;
    padding: 0 1vw;
  }
  .item_title{
    display: flex;
  }
  .item_title p{
    margin-top: 0.2vh;
  }
 
  .item_title span{
    font-size: 0.9vw;
    font-weight: bold;
    color: #ffffff;
    font-family: '微软雅黑';
    margin-left: 0.5vw;
  }
  .tit_class{
    width: 85%;
  }
  .tit_class span{
    font-size: 20px;
  }
  .tit_class img{
    width: 60%;
  }
  .img_right2{
    width: 25%;
  }
  .img_right2 span{
    float: right;
    color: #81D4FF;
    font-size: 16px;
  }
  .img_right{
    width: 28%;
  }
  .img_right img{
    width: 100%;
    height: 0.5vw;
  }
  .zhilian{
    position: relative;
  }
  .user_class{
    width: 100%;
    /* position: absolute;
    left: 15%;
    bottom: 0; */
    line-height: 2;
    display: flex;
    justify-content: center;
  }
  .user_class p:nth-child(1){
    margin-right: 30px;
  }
  .user_class p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .user_class p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .user_class p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .user_class p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUser{
    position: absolute;
    left: 47%;
    top: 5vh;
    line-height: 2;
  }
  .countNjUser p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUser p:nth-child(1) span:nth-child(1), .sumAreaByWork p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(2) span:nth-child(1), .sumAreaByWork p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(3) span:nth-child(1), .sumAreaByWork p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(4) span:nth-child(1), .sumAreaByWork p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(5) span:nth-child(1), .sumAreaByWork p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUser p:nth-child(6) span:nth-child(1), .sumAreaByWork p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWork{
    position: absolute;
    left: 47%;
    top: 6.5vh;
    line-height: 2;
  }
  .sumAreaByWork p span:nth-child(2){
    font-size: 0.7vw;
  }

  .countNjUser2{
    position: absolute;
    left: 47%;
    top: 6.3vh;
    line-height: 2;
  }
  .countNjUser2 p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUser2 p:nth-child(1) span:nth-child(1), .sumAreaByWork2 p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(2) span:nth-child(1), .sumAreaByWork2 p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(3) span:nth-child(1), .sumAreaByWork2 p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(4) span:nth-child(1), .sumAreaByWork2 p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(5) span:nth-child(1), .sumAreaByWork2 p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUser2 p:nth-child(6) span:nth-child(1), .sumAreaByWork2 p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWork2{
    position: absolute;
    left: 47%;
    top: 8.5vh;
    line-height: 2;
  }
  .sumAreaByWork2 p span:nth-child(2){
    font-size: 0.7vw;
  }

  .countNjUserXM{
    position: absolute;
    left: 47%;
    top: 3.5vh;
    line-height: 2;
  }
  .countNjUserXM p span:nth-child(2){
    font-size: 0.7vw;
  }
  .countNjUserXM p:nth-child(1) span:nth-child(1), .sumAreaByWorkXM p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(2) span:nth-child(1), .sumAreaByWorkXM p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(3) span:nth-child(1), .sumAreaByWorkXM p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(4) span:nth-child(1), .sumAreaByWorkXM p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(5) span:nth-child(1), .sumAreaByWorkXM p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(6) span:nth-child(1), .sumAreaByWorkXM p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWorkXM{
    position: absolute;
    left: 47%;
    top: 5vh;
    line-height: 2;
  }
  .sumAreaByWorkXM p span:nth-child(2){
    font-size: 0.7vw;
  }
  
  .countNjUserXM p:nth-child(1) span:nth-child(1), .sumAreaByWorkGs p:nth-child(1) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #007aff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(2) span:nth-child(1), .sumAreaByWorkGs p:nth-child(2) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #00c800;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(3) span:nth-child(1), .sumAreaByWorkGs p:nth-child(3) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #01d0e1;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(4) span:nth-child(1), .sumAreaByWorkGs p:nth-child(4) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #7c00ff;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(5) span:nth-child(1), .sumAreaByWorkGs p:nth-child(5) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: #e8395d;
    vertical-align: middle;
  }
  .countNjUserXM p:nth-child(6) span:nth-child(1), .sumAreaByWorkGs p:nth-child(6) span:nth-child(1){
    display: inline-block;
    width: 0.7vw;
    height: 0.7vw;
    background: skyblue;
    vertical-align: middle;
  }
  .sumAreaByWorkGs{
    position: absolute;
    left: 47%;
    top: 3.8vh;
    line-height: 2;
  }
  .sumAreaByWorkGs p span:nth-child(2){
    font-size: 0.7vw;
  }
</style>




// WEBPACK FOOTER //
// src/components/Index/view/MachineryUsers.vue